import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Circles } from 'react-loader-spinner';
import { authService } from '../services/authService';
import { notifyError, notifySuccess } from "../utils/notifications";
import { UserContext } from "../utils/UserContext";

const GoogleCallback = ({ setIsLogin }) => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { setUser } = useContext(UserContext);
    const [processing, setProcessing] = useState(true);
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        
        const processCallback = async () => {
            const code = searchParams.get('code');
            const state = searchParams.get('state');
            const error = searchParams.get('error');

            // Si Google devolvió error (usuario canceló)
            if (error) {
                notifyError("Inicio de sesión cancelado.");
                navigate('/login');
                return;
            }

            // Si no hay code, algo salió mal
            if (!code) {
                notifyError("No se recibió código de autorización.");
                navigate('/login');
                return;
            }

            try {
                // Procesar el callback con el code
                const data = await authService.googleCallback(code, state);

                // Guardar usuario en contexto
                setUser(data.user);

                // Establecer login y redirigir
                setIsLogin(true);
                navigate('/talleres');
                notifySuccess(`Bienvenido, ${data.user.username}!`);
            } catch (error) {
                console.error('Error en callback de Google:', error);
                notifyError("Error al procesar inicio de sesión con Google.");
                navigate('/login');
            } finally {
                setProcessing(false);
            }
        };

        processCallback();
    }, [searchParams, navigate, setUser, setIsLogin]);

    // Mostrar spinner mientras procesa
    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            flexDirection: 'column',
            gap: '20px'
        }}>
            <Circles
                height="80"
                width="80"
                color="#4fa94d"
                ariaLabel="circles-loading"
            />
            <p>Procesando inicio de sesión...</p>
        </div>
    );
};

export default GoogleCallback;